<template>
  <div class="user">
    <div class="photo-2">
      <div class="photo">
        <img :src="avatar" alt="avatar" />
      </div>
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{ name }}
          <b class="caret"></b>
        </span>
        <span>
          {{title}} for
        </span>
        <span>
          {{company_name}}
        </span>

      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
              <li>
                <a @click="goToPage('/user')">
                  <span class="sidebar-mini"><md-icon>person</md-icon></span>
                  <span class="sidebar-normal">User Profile</span>
                </a>
              </li>
              <li v-if="ifOwner == 'owner'">
                <a @click="goToPage('/company')" >
                  <span class="sidebar-mini"><md-icon>group</md-icon></span>
                  <span class="sidebar-normal">Company Profile</span>
                </a>
              </li>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      isClosed: true,
      name: '',
      title: '',
      // company: '',
      avatar: './img/default-avatar.png',
      ifOwner: '',
      company_name: ''
    };
  },
  mounted() {
    this.ifOwner = this.$store.state.company_type.user_type;
    this.name = this.$store.state.user.full_name;
    this.title = this.$store.state.user.company_position;
    if (this.$store.state.company){
      this.company_name = this.$store.state.company.company_name;
    }
  },
  computed(){
    this.ifOwner = this.$store.state.company_type.user_type;
    if (this.$store.state.company){
      this.company_name = this.$store.state.company.company_name;
    }
    console.log(this.ifOwner)
    console.log(this.company_name)
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
    goToPage: function(link){
      this.$sidebar.showSidebar = false;
      this.$router.push(link);
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
